import { EyeFilled, HeartFilled, HeartOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Row } from "antd";
import { useEffect, useRef, useState } from "react";
import { preCostTypes, registerTypes, SocketMessage } from "../../../../common/types/types";
import { AuctionResponse, BidderAcceptBidStatus, StartStatus, WebsocketTypes } from "../../../types";

import Mess from '../../../../../assets/images/mess.png';
import Facebook from '../../../../../assets/images/facebook.png';
import Zalo from '../../../../../assets/images/zalo.png';
import ConfirmModal from "../../../../common/components/ConfirmModal";
import { useCareProductMutation, useUncareProductMutation } from "../../../../../redux/api/ProductApi";
import { useAppDispatch, useAppSelector } from "../../../../../redux/Hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { isBefore } from "date-fns";
import DenyRightsModal from "./DenyRightsModal";
import PauseReasonModal from "./PauseReasonModal";
import { toggleLoginModal } from "../../../../login/redux/LoginSlice";
interface AuctionItemStatusProps {
    product?: AuctionResponse,
    togglePrepayModal: () => void,
    toggleRegisterModal: () => void,
    triggerFetch: () => void,
    socketMessage?: SocketMessage,
}

const AuctionItemStatus = ({ product, togglePrepayModal, toggleRegisterModal, triggerFetch, socketMessage }: AuctionItemStatusProps) => {
    const [isFavoriteHovering, setIsFavoriteHovering] = useState(false);
    const [visible, setVisible] = useState(false);
    const [denyVisible, setDenyVisible] = useState(false);
    const [pauseVisible, setPauseVisible] = useState(false);

    const [uncareProduct] = useUncareProductMutation();
    const [careProduct] = useCareProductMutation();

    const userState = useAppSelector(state => state.login);
    const auctionState = useAppSelector(state => state.auction);
    const dispatch = useAppDispatch();

    const location = useLocation();
    const navigate = useNavigate();
    const denyModalShowed = useRef(false);

    useEffect(() => {
        if (socketMessage && socketMessage?.type === WebsocketTypes.PAUSE_PRODUCT_STATUTE) {
            setPauseVisible(true);
        }
    }, [socketMessage, socketMessage?.type])

    useEffect(() => {
        // Nếu người dùng bị truất quyền
        if (!denyModalShowed.current &&
            ((socketMessage && (socketMessage?.type === WebsocketTypes.TRUAT_QUYEN ||
                socketMessage?.type === WebsocketTypes.DGV_TRUAT_QUYEN) &&
                socketMessage?.userId === userState.user?.userId)
                || (socketMessage?.type === WebsocketTypes.RUT_LAI_GIA && product?.bidderResponseDTO?.isActive)
                // && product?.bidderResponseDTO?.isActive) ||
                || auctionState.skippedRound)) {
            let value = localStorage.getItem(`${userState.user.userId}-${product?.productId}-${product?.statute.statuteId}`);
            if (!value) {
                // localStorage.setItem(`${userState.user.userId}-${product?.productId}-${product?.statute.statuteId}`, JSON.stringify(true))
                setDenyVisible(true);
                denyModalShowed.current = true; // Chỉ hiển thị modal một lần
            }
        }
    }, [product?.bidderResponseDTO?.isActive, socketMessage?.type, socketMessage?.userId, userState.user.userId,
    auctionState.skippedRound, socketMessage, product?.productId, product?.statute.statuteId])

    const onFavoriteMouseOver = () => {
        setIsFavoriteHovering(true);
    }

    const onFavoriteMouseOut = () => {
        setIsFavoriteHovering(false);
    }

    const onFavoriteClick = () => {
        if (product?.productId && userState.user.userId) {
            if (product?.isCare) {
                // uncare
                uncareProduct({ productId: product?.productId, statuteId: product?.statute.statuteId }).unwrap().then(() => {
                    triggerFetch();
                })
            } else {
                // care
                careProduct({ productId: product?.productId, statuteId: product?.statute.statuteId }).unwrap().then(() => {
                    triggerFetch();
                })
            }
        } else if (!userState.user.userId) {
            // Nếu chưa đăng nhập => hiển thị modal đăng nhập
            dispatch(toggleLoginModal());
        }
    }

    const toggleVisible = () => {
        setVisible(!visible);
    }

    const toggleDenyVisible = () => {
        setDenyVisible(!denyVisible);
    }

    const generateCautionText = () => {
        let cautionText = (
            <></>
        );

        if (product?.statute.bidRule || product?.statute.allowWithdrawPaid) {
            cautionText = (
                <div style={{ fontStyle: 'italic', color: '#BF212B' }}>
                    <div>Lưu ý:</div>
                    {product?.statute.allowWithdrawPaid ?
                        <div>- Nếu rút lại giá đã trả, bạn sẽ bị truất quyền và không được trả lại tiền đặt trước</div>
                        : <></>}
                    {product?.statute.bidRule ?
                        <div>- Người tham gia đấu giá được phép trả giá liên tục</div>
                        : <></>}
                </div>
            )
        }

        return cautionText;
    }

    return (
        <div style={{ marginTop: '20px' }}>
            <Row style={{ width: '100%' }}>
                <Col>
                    <Divider style={{ marginBottom: '15px' }} />
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div className="vh-center" style={{ marginRight: 10 }}>
                            <EyeFilled style={{ fontSize: 25 }} />
                            <span>&nbsp;{product?.views || 0}</span>
                        </div>
                        <div className="vh-center" style={{ marginRight: 10 }}>
                            <div
                                style={{ alignSelf: 'center', cursor: 'pointer' }}
                                onMouseEnter={onFavoriteMouseOver}
                                onMouseLeave={onFavoriteMouseOut}
                                onClick={onFavoriteClick}>
                                {isFavoriteHovering || product?.isCare ?
                                    <HeartFilled style={{ color: '#E59F17', fontSize: 25 }} /> :
                                    <HeartOutlined style={{ color: 'black', fontSize: 25 }} />
                                }

                            </div>
                            <span>&nbsp;{product?.viewcares || 0}</span>
                        </div>
                        <div className="vh-center" style={{ marginRight: 10 }}>
                            <span>Chia sẻ:&nbsp;</span>
                            <a target="_blank" rel="noreferrer" href={`https://m.me`}>
                                <img width={25} src={Mess} alt="messenger" />
                            </a>
                            <a target="_blank" rel="noreferrer" href={
                                `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://dgtt.ospgroup.vn/' + location.pathname)}`
                            }>
                                <img width={25} src={Facebook} alt="facebook" />
                            </a>
                            <a target="_blank" rel="noreferrer" href={`https://chat.zalo.me`}>
                                <img width={25} src={Zalo} alt="zalo" />
                            </a>
                        </div>
                    </div>
                    <Divider style={{ marginTop: '15px' }} />
                </Col>
                <Col>

                    <div className="vh-center">
                        {product?.startStatus === StartStatus.UPCOMING ?
                            <>
                                {/* Đăng ký tham gia */}
                                {product?.seller?.userId !== userState?.user?.userId && (product?.bidderResponseDTO?.registerStatus === registerTypes.NOTREGISTER || !product?.bidderResponseDTO)
                                    && (product?.statute.endRegistrationDate && isBefore(new Date(), product?.statute.endRegistrationDate)) ?
                                    <Button
                                        className="button-light-yellow"
                                        style={{ height: 50, maxWidth: 250, fontSize: 16 }}
                                        onClick={toggleRegisterModal}
                                    >ĐĂNG KÝ THAM GIA ĐẤU GIÁ</Button> : <></>}

                                {/* Nộp phí tham gia */}
                                {userState?.user?.userId && product?.seller?.userId !== userState?.user?.userId && (product?.bidderResponseDTO?.registerStatus === registerTypes.SUBMIT || product?.bidderResponseDTO?.registerStatus === registerTypes.SUCCESS) &&
                                    (product?.bidderResponseDTO?.preCostStatus === preCostTypes.NOTPAY || product?.bidderResponseDTO?.preCostStatus === preCostTypes.FAILED) &&
                                    (product?.statute.endPrePaymentDate && isBefore(new Date(), product?.statute.endPrePaymentDate)) ?
                                    <Button
                                        className="button-green"
                                        style={{ height: 50, maxWidth: 250, fontSize: 16 }}
                                        onClick={togglePrepayModal}
                                    >NỘP PHÍ THAM GIA</Button>
                                    // </div> 
                                    : <></>}
                            </> : <></>}
                        {product?.startStatus === StartStatus.PAUSE ?
                            // Đấu giá tạm dừng
                            <>
                                <Button
                                    onClick={() => setPauseVisible(true)}
                                    style={{
                                        background: '#BF212B',
                                        borderRadius: 10,
                                        color: 'white',
                                        marginLeft: 12,
                                        height: 50,
                                    }}
                                    danger>
                                    Xem lý do
                                </Button>
                            </> :
                            <>
                                {product?.bidderResponseDTO?.registerStatus === registerTypes.INVALID ?
                                    // Đăng ký không hợp lệ
                                    <Button
                                        onClick={toggleVisible}
                                        style={{
                                            background: '#BF212B',
                                            borderRadius: 10,
                                            color: 'white',
                                            marginLeft: 12
                                        }}
                                        danger>
                                        Xem lý do
                                    </Button> :
                                    <>
                                        {product?.bidderResponseDTO?.isActive && (product?.bidderAcceptBid?.status !== BidderAcceptBidStatus.SUCCESS ||
                                            product?.bidderAcceptBid?.user?.userId !== userState.user.userId) ?
                                            // Bị truất quyền
                                            <Button
                                                onClick={toggleDenyVisible}
                                                style={{
                                                    background: '#BF212B',
                                                    borderRadius: 10,
                                                    color: 'white',
                                                    marginLeft: 12,
                                                    height: 50,
                                                }}
                                                danger>
                                                Xem lý do
                                            </Button> : <></>}
                                    </>}
                            </>
                        }

                        {product?.startStatus === StartStatus.FINISH && product?.bidderAcceptBid?.status === BidderAcceptBidStatus.SUCCESS &&
                            product?.bidderAcceptBid?.user?.userId === userState.user.userId ?
                            <Button
                                className="button-light-yellow"
                                style={{ height: 50, maxWidth: 250, fontSize: 16 }}
                                onClick={() => navigate("/contact-us")}
                            >LIÊN HỆ NHẬN GIẢI</Button> : <></>}

                    </div>

                </Col>
            </Row>
            <Row>
                {generateCautionText()}
            </Row>
            {visible ?
                <ConfirmModal
                    noCancelButton
                    visible={visible}
                    onCancel={toggleVisible}
                    onOk={toggleVisible}
                    status="error"
                    title={<>
                        <div>Bạn đã đăng ký tham gia đấu giá không thành công!</div>
                        <div>Lý do: {product?.bidderResponseDTO?.note || ""}</div>
                    </>}
                />
                : <></>}

            {denyVisible ?
                <DenyRightsModal
                    denyVisible={denyVisible}
                    toggleDenyVisible={toggleDenyVisible}
                    note={product?.bidderResponseDTO?.note || ""}
                    bidderId={product?.bidderResponseDTO?.bidderId || 0}
                />
                : <></>}

            {pauseVisible ?
                <PauseReasonModal
                    pauseVisible={pauseVisible}
                    togglePauseVisible={() => setPauseVisible(!pauseVisible)}
                    note={product?.note || product?.statute?.notePaused || ""}
                    productId={product?.productId || 0}
                    statuteId={product?.statute.statuteId || 0}
                    pauseStatute={product?.statute.notePaused && !product?.note ? true : false}
                /> : <></>
            }
        </div>
    )
}

export default AuctionItemStatus;